<template>
    <div>
      <div class="row">
        <div class="col-md-12">
          <div class="top-list-toolbar">
            <div>
              <h4 class="text-primary" @click="backParent">User</h4>
              <ol class="breadcrumb breadcrumb-card-header">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0);" @click="backParent">User</a>
                </li>
                <li class="breadcrumb-item active">
                  <span v-if="user.id === null">New</span>
                  <span v-else>{{ user.username }}</span>
                </li>
              </ol>
              <button type="button" @click="backParent" class="btn btn-sm btn-danger pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
              <button type="button" @click="deleteUser" class="btn btn-sm btn-soft-danger pull-left" v-show="user.id !== null"><i class="fa fa-check" aria-hidden="true"></i> Delete</button>
              <button type="button" @click="updateUser" class="btn btn-sm btn-soft-primary pull-left" v-show="user.id !== null"><i class="fa fa-check" aria-hidden="true"></i> Update</button>
              <button type="button" @click="createUser" class="btn btn-sm btn-soft-primary pull-left" v-show="user.id == null"><i class="fa fa-check" aria-hidden="true"></i> Save</button>
            </div>
          </div>
        </div>
      </div>
      <div class="card card-list">
        <div class="card-header">
          <h5 v-if="user.id === null">New</h5>
          <h5 v-else>{{ user.username }}</h5>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group row">
                        <label for="username" class="col-sm-3 col-form-label text-left">Username <span style="color: red">*</span></label>
                        <div class="col-sm-9">
                            <input type="text" v-model="user.username" class="form-control"/>
                        </div>
                    </div>
                    <div class="form-group row">
                      <label for="name" class="col-sm-3 col-form-label text-left">Name <span style="color: red">*</span></label>
                      <div class="col-sm-9">
                          <input type="text" v-model="user.name" class="form-control"/>
                      </div>
                    </div>
                    <div class="form-group row">
                        <label for="password" class="col-sm-3 col-form-label text-left">Password</label>
                        <div class="col-sm-9">
                            <input type="password" v-model="user.password" class="form-control"/>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="birthday" class="col-sm-3 col-form-label text-left">Birthday</label>
                        <div class="col-sm-9">
                          <datetime v-model="user.birthday" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local"></datetime>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="birthplace" class="col-sm-3 col-form-label text-left">Birth Place</label>
                        <div class="col-sm-9">
                            <input type="text" v-model="user.birthplace" class="form-control"/>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="address" class="col-sm-3 col-form-label text-left">Address</label>
                        <div class="col-sm-9">
                            <textarea v-model="user.address" class="form-control"/>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group row">
                        <label for="branch_no" class="col-sm-3 col-form-label text-left">Company <span style="color: red">*</span></label>
                        <div class="col-sm-9">
                          <select v-model="user.company_no" class="form-control">
                            <option v-for="c in companyList" :key="c.branch_no" :value="c.company_no">
                              {{ c.name }}
                            </option>
                          </select>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="role_id" class="col-sm-3 col-form-label text-left">Role <span style="color: red">*</span></label>
                        <div class="col-sm-9">
                          <select class="custom-select" v-model="user.role_id" multiple>
                            <option v-for="cat in roleList" :key="cat.id" v-bind:value="cat.id">
                                {{ cat.name }}
                            </option>
                          </select>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="phone" class="col-sm-3 col-form-label text-left">Phone</label>
                        <div class="col-sm-9">
                            <input type="text" v-model="user.phone" class="form-control"/>
                        </div>
                    </div>
                    <div class="form-group row">
                      <label for="email" class="col-sm-3 col-form-label text-left">Email <span style="color: red">*</span></label>
                      <div class="col-sm-9">
                        <input type="text" v-model="user.email" class="form-control"/>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
        </div>
      </div>
      <!-- <pre>{{ user }}</pre> -->
    </div>
</template>

<script>
import axios from 'axios'
import { getHeader, userUrl } from '../../config'
import { mapState } from 'vuex'

export default {
  name: 'UserForm',
  props: ['user'],
  methods: {
    async deleteUser () {
      await this.$swal.fire({
        title: 'Are you sure unlock this?',
        text: "You won't be able to revert this!",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#28A745',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Delete it!'
      }).then((result) => {
        if (result) {
          axios.delete(userUrl + '/' + this.user.id, { headers: getHeader() })
            .then(response => {
              console.log(response.data.message)
              this.backParent()
            })
            .catch(error => {
              console.log(error)
              console.log(error.response)
              this.$swal('Error', error.response.data.message, 'error')
              throw error
            })
        }
      })
    },
    backParent: function () {
      this.$emit('backClicked')
    },
    updateUser () {
      axios.put(userUrl + '/' + this.user.id, this.user, { headers: getHeader() })
        .then(response => {
          this.$swal(
            'User',
            response.data.message,
            'success'
          )
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            '',
            'error'
          )
        })
    },
    createUser () {
      axios.post(userUrl, this.user, { headers: getHeader() })
        .then(response => {
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error!!',
            'Cannot create user',
            'error'
          )
        })
    }
  },
  computed: {
    ...mapState({
      branchList: state => state.branches.branchList,
      roleList: state => state.users.roles,
      positionList: state => state.users.positions,
      companyList: state => state.companies.companyList
    })
  }
}
</script>
